import store from '../store/index'
export default (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
  } else {
    next('/auth')
  }
}
